import {
  addTimeToDateString,
  calculateBaseDateRange,
} from "src/utils/formatTime";
import { format } from "date-fns";
import axios from "../util/axios";
import Token from "../util/Token";

//DASHBOARD URL
const URL = "/cms/v1/team";

async function getStatistics(teamId, timeInterval) {
  Token.setAuthToken();
  return await axios.get(`${URL}/${teamId}/dashboard_stats`, {
    params: { ...timeInterval },
  });
}
async function getIndividualStatistics(teamId, statsUrl, timeInterval, field) {
  try {
    Token.setAuthToken();
    const updatedTimeInterval = calculateBaseDateRange(timeInterval);
    const { status, data } = await axios.get(`${URL}/${teamId}/${statsUrl}`, {
      params: { ...updatedTimeInterval },
    });
    if (status === 200 && data.success) {
      return { ...data.data, field };
    }
  } catch (error) {
    // Error handling
  }
}

// New function specifically for transactions graph data that passes start, end, baseStart, and baseEnd
async function getTransactions(teamId, timeInterval) {
  try {
    Token.setAuthToken();
    
    // Calculate baseStart and baseEnd for comparison (previous period)
    const baseTimeInterval = calculateBaseDateRange(timeInterval);
    
    // Format dates to YYYY-MM-DD format for the API
    const formatDateForAPI = (dateString) => {
      const date = new Date(dateString);
      // Use local date parts to ensure we send the IST date, not the UTC date.
      // This matches the new backend CONVERT_TZ logic.
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    const params = { 
      start: formatDateForAPI(timeInterval.start),
      end: formatDateForAPI(timeInterval.end),
      baseStart: formatDateForAPI(baseTimeInterval.baseStart),
      baseEnd: formatDateForAPI(baseTimeInterval.baseEnd)
    };
    
    
    const { status, data } = await axios.get(`${URL}/${teamId}/transactions/graph`, {
      params
    });
    
    if (status === 200 && data.success) {
      return data.data; // Return the array directly instead of spreading it
    }
    
    return null;
  } catch (error) {
    return null;
  }
}
const dashboardService = {
  getStatistics,
  getIndividualStatistics,
  getTransactions,
};
export default dashboardService;
